import { render, staticRenderFns } from "./DefineQuery.vue?vue&type=template&id=4b896458&scoped=true&"
import script from "./DefineQuery.vue?vue&type=script&lang=ts&"
export * from "./DefineQuery.vue?vue&type=script&lang=ts&"
import style0 from "./DefineQuery.vue?vue&type=style&index=0&id=4b896458&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b896458",
  null
  
)

export default component.exports